import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">Ecommerce Middleware</div>`
})
export class AppFooter {}
